/** Split prose at sentence boundaries while retaining its inline markup and source links. */
const textOf=node=>node.type==='text'?node.value:(node.children || []).map(textOf).join('');
export const normalizeReportCopy=content=>content.replace(/(^|>)(\s*)(?:#{1,6}\s*)?(?:리드\s*문장|lead\s*sentence|headline|개요\s*문장)(?=\s|[:：—–-]|<|$)[ \t]*(?:[:：—–-][ \t]*)?/gim,'$1$2');
function sliceNode(node,start,end) {
  if(node.type==='text')return {...node,value:node.value.slice(start,end)};
  let offset=0;
  const children=(node.children || []).flatMap(child=>{
    const length=textOf(child).length,from=Math.max(0,start-offset),to=Math.min(length,end-offset);
    offset+=length;
    return to>from?[sliceNode(child,from,to)]:[];
  });
  return {...node,children};
}
function splitParagraph(node) {
  const text=textOf(node);
  if(text.length<320 || /"tagName":"(?:img|code|br)"/.test(JSON.stringify(node)))return [node];
  const sentences=[...new Intl.Segmenter('ko',{granularity:'sentence'}).segment(text)];
  const ends=[];let start=0;
  for(const sentence of sentences) {
    const end=sentence.index+sentence.segment.length;
    if(end-start>=180){ends.push(end);start=end;}
  }
  if(start<text.length)ends.push(text.length);
  start=0;
  return ends.map(end=>{const part=sliceNode(node,start,end);start=end;return part;});
}
export const readableReportLists=()=>readableReportParagraphs({sentenceLists:true});
export function readableReportParagraphs({sentenceLists=false}={}) {
  return tree=>{
    function visit(node) {
      if(!node.children)return;
      node.children=node.children.flatMap(child=>{
        if(child.type==='element'&&child.tagName==='p') {
          if(sentenceLists) {
            const text=textOf(child),segments=[...new Intl.Segmenter('ko',{granularity:'sentence'}).segment(text)];
            const ends=segments.filter(segment=>/[.!?]\s*$/.test(segment.segment)&&/[가-힣]/.test(segment.segment)).map(segment=>segment.index+segment.segment.length);
            if(ends.length>=2) {
              ends[ends.length-1]=text.length;let start=0;
              return [{type:'element',tagName:'ul',properties:{},children:ends.map(end=>{const part=sliceNode(child,start,end);start=end;return {type:'element',tagName:'li',properties:{},children:part.children};})}];
            }
          }
          return splitParagraph(child);
        }
        visit(child);return [child];
      });
      const grouped=[];
      for(let i=0;i<node.children.length;i++) {
        const child=node.children[i];
        if(child.tagName==='p'&&/^\d+[.)]\s/.test(textOf(child))) {
          const items=[];let end=i;
          while(end<node.children.length) {
            if(node.children[end].type==='text'&&!textOf(node.children[end]).trim()){end++;continue;}
            if(node.children[end].tagName!=='p'||!/^\d+[.)]\s/.test(textOf(node.children[end])))break;
            const item=node.children[end],prefix=textOf(item).match(/^\d+[.)]\s*/)[0];
            items.push({type:'element',tagName:'li',properties:{},children:sliceNode(item,prefix.length,textOf(item).length).children});end++;
          }
          if(items.length>=2){grouped.push({type:'element',tagName:'ol',properties:{},children:items});i=end-1;continue;}
        }
        grouped.push(child);
      }
      node.children=grouped;
    }
    visit(tree);
  };
}
